/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type { CarrierWithProperties } from "../models/index";
import {
  CarrierWithPropertiesFromJSON,
  CarrierWithPropertiesToJSON,
} from "../models/index";

export interface ExportTypesRequest {
  carrierWithProperties?: CarrierWithProperties | null;
}

/**
 *
 */
export class OpenApiTypesApi extends runtime.BaseAPI {
  /**
   */
  async exportTypesRaw(
    requestParameters: ExportTypesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    const queryParameters: any = {};

    if (requestParameters["carrierWithProperties"] != null) {
      queryParameters["carrierWithProperties"] =
        requestParameters["carrierWithProperties"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/types`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async exportTypes(
    requestParameters: ExportTypesRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.exportTypesRaw(requestParameters, initOverrides);
  }
}
